import type { ConversationsTableResult } from "@/types/tables/ConversationsTable"

import { incrementCount, sortCountEntries } from "./conversationsSummaryMetrics"
import type { CountEntry } from "./conversationsSummaryTypes"
import {
  isUnsuccessfulStatus,
  normalizeStatus,
} from "./conversationsSummaryWindow"

export function getFailureStatusCounts(
  rows: ConversationsTableResult[],
): CountEntry[] {
  const counts = new Map<string, CountEntry>()
  rows.forEach((row) => {
    if (!isUnsuccessfulStatus(row)) {
      return
    }
    const status = normalizeStatus(row.run_status || row.error_status)
    incrementCount(counts, status)
  })
  return sortCountEntries(counts)
}
